let warehouseData = [
    {
        name: "INNH Gurgaon",
        states: "Ladakh, Uttarakhand, Uttar Pradesh, Haryana, Delhi, Punjab, Chandigarh, Jammu & Kashmir, Himanchal Pradesh, Rajasthan, Maharastra, Maharashtra, Madhya Pradesh, Chattisgarh, Gujarat, Goa, Dadar Daman & Diu, Lakshwadeep, Andaman & Nicobar, Tamil Nadu, Kerala, Puducherry, Karnataka, Telangana, Andhra Pradesh, West Bengal, Odisha, Bihar, Jharkhand, Arunachal Pradesh, Assam, Manipur, Meghalaya, Mizoram, Nagaland, Sikkim, Tripura",
        id: 68464640190
    }
];

/**
let warehouseData = [
    {
        name: "INNH Gurgaon",
        states: "Ladakh, Uttarakhand, Uttar Pradesh, Haryana, Delhi, Punjab, Chandigarh, Jammu & Kashmir, Himanchal Pradesh, Rajasthan",
        id: 68464640190
    },
    {
        name: "INWB Bhiwandi",
        states: "Maharastra, Maharashtra, Madhya Pradesh, Chattisgarh, Gujarat, Goa, Dadar Daman & Diu, Lakshwadeep",
        id: 68464738494
    },
    {
        name: "INSC Chennai",
        states: "Andaman & Nicobar, Tamil Nadu, Kerala, Puducherry, Karnataka, Telangana, Andhra Pradesh",
        id: 68464705726
    },
    {
        name: "INEA Kolkata",
        states: "West Bengal, Odisha, Bihar, Jharkhand, Arunachal Pradesh, Assam, Manipur, Meghalaya, Mizoram, Nagaland, Sikkim, Tripura",
        id: 68464672958
    }
];
*/


let stateCode = [
    {
        name: "Ladakh",
        code: "LA"
    },
    {
        name: "Uttarakhand",
        code: "UT"
    },
    {
        name: "Andaman & Nicobar",
        code: "AN"
    },
    {
        name: "Arunachal Pradesh",
        code: "AR"
    },
    {
        name: "Dadar Daman & Diu",
        code: "DH"
    },
    {
        name: "Lakshwadeep",
        code: "LD"
    },
    {
        name: "Meghalaya",
        code: "ML"
    },
    {
        name: "Manipur",
        code: "MN"
    },
    {
        name: "Mizoram",
        code: "MZ"
    },
    {
        name: "Nagaland",
        code: "NL"
    },
    {
        name: "Puducherry",
        code: "PY"
    },
    {
        name: "Sikkim",
        code: "SK"
    },
    {
        name: "Telangana",
        code: "TG"
    },
    {
        name: "Tripura",
        code: "TR"
    },
    {
        name: "Uttar Pradesh",
        code: "UP"
    },
    {
        name: "Karnataka",
        code: "KA",
    },
    {
        name: "Haryana",
        code: "HR"
    },
    {
        name: "West Bengal",
        code: "WB"
    },
    {
        name: "Tamil Nadu",
        code: "TN"
    },
    {
        name: "Maharastra",
        code: "MH"
    },
    {
        name: "Delhi",
        code: "DL"
    },
    {
        name: "Odisha",
        code: "OR"
    },
    {
        name: "Assam",
        code: "AS"
    },
    {
        name: "Bihar",
        code: "BR"
    },
    {
        name: "Jharkhand",
        code: "JH"
    },
    {
        name: "Punjab",
        code: "PB"
    },
    {
        name: "Chandigarh",
        code: "CH"
    },
    {
        name: "Jammu & Kashmir",
        code: "JK"
    },
    {
        name: "Himanchal Pradesh",
        code: "HP"
    },
    {
        name: "Rajasthan",
        code: "RJ"
    },
    {
        name: "Madhya Pradesh",
        code: "MP"
    },
    {
        name: "Kerala",
        code: "KL"
    },
    {
        name: "Andhra Pradesh",
        code: "AP"
    },
    {
        name: "Gujarat",
        code: "GJ"
    },
    {
        name: "Goa",
        code: "GA"
    },
    {
        name: "Chattisgarh",
        code: "CT"
    }
]